import './social_profile_view.js.coffee'
Namespace 'Customer.Users'

class Customer.Users.LinkedInProfileView extends Customer.Users.SocialProfileView
  template: JST['backbone/templates/customer/users/linked_in_profile']
  id: 'linkedin-profile'
